import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
    FaGraduationCap, FaCalendarAlt,
    FaDatabase, FaCode, FaLaptop, FaChartLine, FaUsers,
    FaFlask, FaBook, FaNetworkWired,
    FaGamepad, FaUserTie
} from 'react-icons/fa';

const courses = [
    {
        title: "Project Management",
        provider: "Injaz Organization",
        date: "August 2023",
        icon: FaUsers,
        category: "Management"
    },
    {
        title: "Marketing Diploma 3 in 1: The Essentials of an MBA (Master of Business Administration) - Ehab Mesallum",
        provider: "Udemy",
        date: "2026 - In progress",
        icon: FaUserTie,
        category: "Marketing"
    },
    {
        title: "Agentic AI & RAG Training",
        provider: "Gaza Sky Geeks",
        date: "May 2026",
        icon: FaCode,
        category: "Programming"
    },
    {
        title: "Django Bootcamp",
        provider: "Zero To Mastery (ZTM)",
        date: "May 2026",
        icon: FaBook,
        category: "Programming"
    },
    {
        title: "Game Development Training",
        provider: "Gaza Sky Geeks",
        date: "April 2026 - Present",
        icon: FaGamepad,
        category: "Game Development"
    },
    {
        title: "Introduction to Linux (LFS101)",
        provider: "The Linux Foundation",
        date: "April 2026",
        icon: FaNetworkWired,
        category: "Tools"
    },
    {
        title: "A B C of Coding to Build AI Agents",
        provider: "Analytics Vidhya",
        date: "March 2026",
        icon: FaCode,
        category: "Programming"
    },
    {
        title: "Make a Flappy Bird Game From Scratch in Unity 6.3 & C#",
        provider: "Udemy",
        date: "2026",
        icon: FaGamepad,
        category: "Game Development"
    },
    {
        title: "Unity 2D Game Development with C#",
        provider: "Udemy",
        date: "2026",
        icon: FaGamepad,
        category: "Game Development"
    },
    {
        title: "Introduction to JavaScript Security LFS184",
        provider: "The Linux Foundation",
        date: "2026",
        icon: FaNetworkWired,
        category: "Programming"
    },
    {
        title: "Creating Effective Documentation for Developers",
        provider: "The Linux Foundation",
        date: "2026",
        icon: FaNetworkWired,
        category: "Tools"
    },
    {
        title: "Databases (SQL Server)",
        provider: "Metigator Channel - YouTube",
        date: "November 2025",
        icon: FaDatabase,
        category: "Database"
    },
    {
        title: "Mastering C#.NET",
        provider: "Metigator Channel - YouTube",
        date: "October 2025",
        icon: FaCode,
        category: "Programming"
    },
    {
        title: "C# Basics course",
        provider: "Guruhub",
        date: "October 2025",
        icon: FaCode,
        category: "Programming"
    },
    {
        title: "Computer Hardware Basics",
        provider: "Cisco Networking Academy",
        date: "August 2025",
        icon: FaLaptop,
        category: "Hardware"
    },
    {
        title: "Appian Development",
        provider: "Appian platform",
        date: "March 2025",
        icon: FaCode,
        category: "Low-Code"
    },
    {
        title: "Data Analysis Nanodegree",
        provider: "Udacity",
        date: "August 2024",
        icon: FaChartLine,
        category: "Data Science"
    },
    {
        title: "JavaScript training program",
        provider: "Gaza Sky Geeks",
        date: "May 2023",
        icon: FaCode,
        category: "Programming"
    },
    {
        title: "Python Bootcamp",
        provider: "Gaza Sky Geeks",
        date: "2023",
        icon: FaCode,
        category: "Programming"
    },
    {
        title: "Research Contest",
        provider: "IEEE",
        date: "2023",
        icon: FaFlask,
        category: "Research"
    },
    {
        title: "Django Bootcamp",
        provider: "Gaza Sky Geeks",
        date: "2022",
        icon: FaBook,
        category: "Programming"
    },
    {
        title: "Version Control with Git",
        provider: "learn.udacity.com",
        date: "2022",
        icon: FaNetworkWired,
        category: "Tools"
    },
    {
        title: "Printed Circuit Board (PCB)",
        provider: "Institute of Electrical and Electronics Engineers",
        date: "November 2021",
        icon: FaLaptop,
        category: "Hardware"
    },
   
    
];

const categoryColors = {
    "Programming": {
        bg: "bg-pink-100",
        text: "text-pink-800",
        icon: "text-pink-600"
    },
    "Database": {
        bg: "bg-olive-100",
        text: "text-olive-700",
        icon: "text-olive-600"
    },
    "Hardware": {
        bg: "bg-gray-100",
        text: "text-gray-800",
        icon: "text-gray-600"
    },
    "Low-Code": {
        bg: "bg-pink-100",
        text: "text-pink-800",
        icon: "text-pink-600"
    },
    "Data Science": {
        bg: "bg-olive-100",
        text: "text-olive-700",
        icon: "text-olive-600"
    },
    "Management": {
        bg: "bg-pink-100",
        text: "text-pink-800",
        icon: "text-pink-600"
    },
    "Research": {
        bg: "bg-gray-100",
        text: "text-gray-800",
        icon: "text-gray-600"
    },
    "Tools": {
        bg: "bg-gray-100",
        text: "text-gray-800",
        icon: "text-gray-600"
    },
    "Game Development": {
        bg: "bg-olive-100",
        text: "text-olive-700",
        icon: "text-olive-600"
    }, 
    "Marketing": {
    bg: "bg-rose-100",
    text: "text-rose-800",
    icon: "text-rose-600"
},
};

const Courses = () => {
    const [filter, setFilter] = useState('All');

    const categories = ['All', ...new Set(courses.map(course => course.category))];

    const filteredCourses =
        filter === 'All'
            ? courses
            : courses.filter(course => course.category === filter);

    return (
        <section id="courses" className="py-20 bg-cream">
            <div className="container mx-auto px-4">

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                    className="mb-12 text-center"
                >
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full mb-4 shadow-md">
                        <FaGraduationCap className="text-pink-600 text-2xl" />
                    </div>

                    <h2 className="text-4xl font-bold text-gray-800 mb-4">
                        Courses & Certifications
                    </h2>

                    <p className="text-gray-600 text-lg max-w-2xl mx-auto mb-8">
                        Committed to technical growth and staying ahead of industry trends
                    </p>

                    <div className="w-24 h-1 bg-gradient-to-r from-pink-500 to-rose-500 mx-auto"></div>
                </motion.div>

                <div className="flex flex-wrap justify-center gap-3 mb-10">
                    {categories.map((category) => (
                        <button
                            key={category}
                            onClick={() => setFilter(category)}
                            className={`px-4 py-2 rounded-full font-medium transition-all ${
                                filter === category
                                    ? 'bg-gradient-to-r from-pink-500 to-rose-500 text-white shadow-lg'
                                    : 'bg-white text-gray-700 hover:bg-pink-50 shadow'
                            }`}
                        >
                            {category}
                        </button>
                    ))}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {filteredCourses.map((course, index) => {
                        const colors = categoryColors[course.category];
                        const IconComponent = course.icon;

                        return (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, scale: 0.95 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                viewport={{ once: true }}
                                className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 group"
                            >
                                <div className="p-6">

                                    <div className="flex items-start justify-between mb-4">
                                        <div className={`p-3 rounded-lg ${colors.bg} mr-4`}>
                                            <IconComponent className={`text-xl ${colors.icon}`} />
                                        </div>

                                        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${colors.bg} ${colors.text}`}>
                                            {course.category}
                                        </span>
                                    </div>

                                    <h3 className="text-lg font-bold text-gray-800 mb-2 group-hover:text-pink-600 transition">
                                        {course.title}
                                    </h3>

                                    <div className="text-gray-600 mb-3">
                                        {course.provider}
                                    </div>

                                    <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-100">
                                        <div className="flex items-center text-sm text-pink-600 font-medium">
                                            <FaCalendarAlt className="mr-2" />
                                            <span>{course.date}</span>
                                        </div>

                                        <div className="w-8 h-8 rounded-full bg-pink-100 flex items-center justify-center group-hover:bg-pink-200 transition">
                                            <span className="text-pink-600 font-bold">✓</span>
                                        </div>
                                    </div>

                                </div>
                            </motion.div>
                        );
                    })}
                </div>

                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                    className="mt-12 text-center"
                >
                    <div className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-pink-500 to-rose-500 text-white rounded-full font-semibold">
                        <FaGraduationCap className="mr-2" />
                        {filteredCourses.length} Courses Completed
                    </div>
                </motion.div>

            </div>
        </section>
    );
};

export default Courses;